<template>
  <div class="w-100">
    <h2 class="mb-4">Client Details</h2>
    <name-fields v-model="clientNameFieldsStatus"/>
    <email-field v-model="clientEmailFieldStatus"/>
    <address-field v-model="clientAddressFieldStatus"/>
    <medical-note/>
  </div>
</template>

<script>
import { StatusEmitterMixin } from '@/mixins/GeneralRegistration/StatusEmitterMixin'
import ClientNameFields from './ClientNameFields.vue'
import ClientEmailField from './ClientEmailField.vue'
import ClientAddressField from './ClientAddressField.vue'
import ClientMedicalNote from './ClientMedicalNote.vue'

export default {
  name: 'ClientDetailsSection',
  mixins: [StatusEmitterMixin],
  data () {
    return {
      clientNameFieldsStatus: {},
      clientEmailFieldStatus: {},
      clientAddressFieldStatus: {}
    }
  },
  computed: {
    statuses () {
      return [
        this.clientNameFieldsStatus,
        this.clientEmailFieldStatus,
        this.clientAddressFieldStatus
      ]
    },
    validated () {
      return this.statuses.every(s => !!s.validated)
    }
  },
  components: {
    'name-fields': ClientNameFields,
    'email-field': ClientEmailField,
    'address-field': ClientAddressField,
    'medical-note': ClientMedicalNote
  }
}
</script>
